import React, { useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import { CheckboxField, DropDownField, TextInputField } from "../../../helpers";

const TranspotationDetails = (props) =>{
    const { 
        isTransporterAvailable, 
        pmCompanyBillAddrDetails, 
        buyerShipAddrDetails,
        setIsTransporterAvailable, 
        logisticPartners,
        transportationDetails, 
        uniqueLogisticPartners, 
        setTransportationDetails,
        dispatchDetails
    } = props
    // const logisticPartnerGSTINs = logisticPartners?.filter(eachLogisticPartner => eachLogisticPartner?.partnerName === transportationDetails?.transporterName)
    const [logisticPartnerGSTINs, setLogisticsPartnerGSTINs] = useState([])

    const handleCheckboxChange = (e) => {
        setTransportationDetails({})
        setTransportationDetails(prevState => ({...prevState, [e.target.name] : e.checked}))
    }

    const handleTransportationChange = (e) => {
        if (e.target.name === "transporterName"){
            const logisticPartnerGSTINs = logisticPartners?.filter(eachLogisticPartner => eachLogisticPartner?.partnerName === e.target.value)
            console.log("name", logisticPartnerGSTINs, e.target.name)
            if (logisticPartnerGSTINs.length === 1){
                setTransportationDetails(prevState => ({...prevState, "transporterGSTIN" : logisticPartnerGSTINs[0]?.GSTIN}))
            }
            setLogisticsPartnerGSTINs(logisticPartnerGSTINs)
        }
        setTransportationDetails(prevState => ({...prevState, [e.target.name] : e.target.value}))   
    }

    return (
        <div className="p-card flex flex-column">
            <div className="grid flex">
                <div className="flex col-12 md:col-4">
                    <div className="my-1 flex">
                        <RadioButton inputId="" value="Transporter" onChange={() => { setIsTransporterAvailable(true); setTransportationDetails({}) }} checked={isTransporterAvailable} />
                        <label htmlFor="" className="ml-1 text-sm">Transporter</label>
                    </div>
                    <div className="my-1 flex ml-3">
                        <RadioButton inputId="" value="" onChange={() => { setIsTransporterAvailable(false); setTransportationDetails({ byRoad: true }); setLogisticsPartnerGSTINs() }} checked={!isTransporterAvailable} />
                        <label htmlFor="" className="ml-1 text-sm">Other Mode</label>
                    </div>
                </div>
            </div>
            <div className="grid flex">
                <div className="flex col-12 mb-2 md:col-12 lg:mb-0 md:p-0 p-2">
                    {
                        isTransporterAvailable ?
                            <>
                                <div className="flex flex-row col-12 md:col-12 lg:col-6 lg:mb-0">
                                    <div className="flex flex-column col-12 lg:col-7 lg:mb-0">
                                        <DropDownField name="transporterName" labelText="Transporter Name" value={transportationDetails?.transporterName} options={uniqueLogisticPartners} optionLabel="partnerName" optionValue="partnerName" onChange={e => handleTransportationChange(e)} required />
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-5 lg:mb-0">
                                        <DropDownField name="transporterGSTIN" labelText=" Transporter GSTIN" value={logisticPartnerGSTINs?.length === 1 ? logisticPartnerGSTINs[0]?.GSTIN : transportationDetails?.transporterGSTIN} options={logisticPartnerGSTINs} optionLabel="GSTIN" optionValue="GSTIN" onChange={e => handleTransportationChange(e)} required />
                                    </div>
                                </div>
                            </>
                            :
                            <div className="flex flex-row col-12 md:col-12 lg:col-6 lg:mb-0">
                                <div className="col-12 md:col-12 lg:col-7 lg:mb-0">
                                    <label style={{ fontSize: "12px" }}>Mode Type<span style={{ color: "red" }} className="from-required">*</span></label>
                                    <div className="grid flex flex-row mt-2">
                                        <div className="flex col-3">
                                            <CheckboxField label="Road" name="byRoad" checked={transportationDetails?.byRoad} onChange={(e) => handleCheckboxChange(e)} />
                                        </div>
                                        <div className="flex col-3">
                                            <CheckboxField label="Rail" name="byRail" checked={transportationDetails?.byRail} onChange={(e) => handleCheckboxChange(e)} />
                                        </div>
                                        <div className="flex col-3">
                                            <CheckboxField label="Air" name="byAir" checked={transportationDetails?.byAir} onChange={(e) => handleCheckboxChange(e)} />
                                        </div>
                                        <div className="flex col-3">
                                            <CheckboxField label="Ship" name="byShip" checked={transportationDetails?.byShip} onChange={(e) => handleCheckboxChange(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-column col-12 lg:col-5 lg:mb-0">
                                    <TextInputField name="vehicleNo" labelText="Vehicle No / Rail / Air / Ship Details" value={transportationDetails?.vehicleNo} onChange={e => handleTransportationChange(e)} required />
                                </div>
                            </div>
                    }
                    <div className="flex flex-row col-12 md:col-12 lg:col-2 lg:mb-0"></div>
                    <div className="flex col-12 md:col-12 lg:col-4 lg:mb-0" >
                        <div className="flex flex-column col-12 lg:col-6 lg:mb-0">
                            <TextInputField name="transportationDistance" keyfilter={"pnum"} labelText="Transportation Distance (km)" value={transportationDetails?.transportationDistance} onChange={e => handleTransportationChange(e)} />
                        </div>
                        <div className="col-6 lg:col-6">
                            <p className="text-sm mt-0"><a target="__blank" href="https://einvoice1.gst.gov.in/Others/GetPinCodeDistance">Click Here</a> &nbsp;&nbsp;to calculate distance between {dispatchDetails?.pinCode} to {buyerShipAddrDetails?.pinCode}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TranspotationDetails;